module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-2.e41d9496.jpg";